export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5222.8a8bd0c8.jpg";